import CrudTab from 'react/containers/pages/CrudTab';

class DataImport extends CrudTab {

  static tabName = 'dataimport'

  componentDidMount() {
    this.router = new App.Routers.DataImport();
    this.router.show();
  }

  componentDidUpdate() {
    const { active } = this.props;
    if (active && this.router) {
      this.router.view.processingStatus.updateNow();
    }
  }

}

export default DataImport;
